import React from 'react';
import BasicRadioButton from './BasicRadioButton';
import { OptionValue } from '../../services/types/Misc';

interface Props {
  name: string;
  elements: OptionValue[];
  value: number;
  onChange: (value: number) => void;
  direction?: 'horizontal' | 'vertical' | undefined;
}

const BasicRadioGroup: React.FC<Props> = ({ name, elements, value, onChange, direction }) => {
  const drawRadio = (option: OptionValue) => (
    <div key={option.id} className="basic-radio-btn">
      <BasicRadioButton
        id={option.htmlId}
        name={name}
        label={option.text}
        radioValue={option.id}
        active={value === option.id}
        onChange={onChange}
        disabled={option.disabled}
      />
    </div>
  );

  const classNameDirection = direction ? `radio-group-${direction}` : 'radio-group-horizontal';

  return <div className={classNameDirection}>{elements.map((option) => drawRadio(option))}</div>;
};

export default React.memo(
  BasicRadioGroup,
  (prevProps, nextProps) => prevProps.value === nextProps.value
);
